export default __webpack_public_path__ + "static/media/SDC.19b37962.png";